<app-split [id]="splitComponentId">
  @if (annexDetails) {
    <div class="annex-details-container">
      <div class="back-bar">
        <button mat-button (click)="goToAgreement()" class="back-link">
          <mat-icon>arrow_back</mat-icon>
          {{ 'Annex.BackToAgreement' | translate }}
        </button>
      </div>

      <div class="annex-header">
        <h1>
          {{ 'Annex.AnnexFromDate' | translate }}
          {{ annexDetails.Annex.AnnexConclusionDate | date: 'yyyy-MM-dd' }}
          {{ 'Annex.EffectiveFrom' | translate }}
          {{ annexDetails.Annex.AnnexStartDate | date: 'yyyy-MM-dd' }}
          ({{ annexDetails.Annex.AnnexStatus }})
          <app-annex-imported-badge [visible]="annexDetails.Annex.IsImported" />
        </h1>
      </div>

      <div class="annex-navigation">
        <button
          class="nav-button nav-button--left"
          [disabled]="!previousAnnexId"
          (click)="goToPreviousAnnex()"
          [attr.aria-label]="'Annex.PreviousAnnex' | translate"
          [matTooltip]="'Annex.PreviousAnnex' | translate"
        >
          <mat-icon>chevron_left</mat-icon>
          <span>{{ 'Annex.PreviousAnnex' | translate }}</span>
        </button>

        @if (!annexDetails.Annex.IsImported) {
          <button
            mat-raised-button
            color="accent"
            type="button"
            class="annex-download-btn"
            (click)="onDownloadAnnexClick()"
            [attr.aria-label]="'Annex.DownloadAnnex' | translate"
            [matTooltip]="'Annex.DownloadAnnex' | translate"
          >
            <mat-icon>download</mat-icon>
            <span>{{ 'Annex.DownloadAnnex' | translate }}</span>
          </button>
        }

        <button
          class="nav-button nav-button--right"
          [disabled]="!nextAnnexId"
          (click)="goToNextAnnex()"
          [attr.aria-label]="'Annex.NextAnnex' | translate"
          [matTooltip]="'Annex.NextAnnex' | translate"
        >
          <span>{{ 'Annex.NextAnnex' | translate }}</span>
          <mat-icon>chevron_right</mat-icon>
        </button>
      </div>

      <app-summary-step
        mode="details"
        [agreement]="annexDetails.WorkerAgreement"
        [annexData]="annexDetails.Annex"
        [dataForAnnex]="annexDetails.WorkerAgreement"
      >
      </app-summary-step>
    </div>
  }
</app-split>
